import TicketWidget from './TicketWidget';

export default TicketWidget;
